export default __webpack_public_path__ + "static/media/actividad-16.996b1fd4.mp3";